import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
		computed,
		onMounted
	} from 'vue'

	// router
	import {
		useRoute
	} from 'vue-router'
	
	import MainLayout from './layouts/MainLayout.vue'
	
	// api
	import axios from 'axios'

	// store
	import { 
		store as _valueListStore
	} from '@/store/valueLists'

	import {
		ValueList,
		ValueListValue
	} from '@/types'

	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// vue
	const valueListStore = _valueListStore()
	const isLoaded = true

	const route = useRoute()
	const layout = computed(() => {
		return route.meta.layout || MainLayout
	})

	onMounted(async ()=>{


		let res = await axios.get(`/manufacturers`)
		valueListStore.valueList['manufacturers'] = res.data
	})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return isLoaded
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})